import { QueryClient } from '@tanstack/react-query';

/**
 * Invalidates the transactions query to trigger a refresh of the transactions list
 * @param queryClient The QueryClient instance
 */
export const invalidateTransactions = (queryClient: QueryClient) => {
  if (!queryClient) return;
  
  console.log('Invalidating transactions query');
  queryClient.invalidateQueries({ queryKey: ['transactions'] });
}; 